import useUserNavigationUtils from "@hooks/useUserNavigationUtils"

import { faIcon } from "@utils/faIcon"

import NavSidebarItem from "@organisms/NavSidebar/components/NavSidebarItem/NavSidebarItem"

export default function WhatsNew() {
    const { openChangelog } = useUserNavigationUtils()

    return (
        <NavSidebarItem
            onClick={() => openChangelog()}
            label="What's new"
            icon={faIcon({ name: "bullhorn", style: "regular" })}
            iconActive={faIcon({ name: "bullhorn", style: "solid" })}
        />
    )
}
